import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";
import { PaymentCard } from "./cardTypes";
import { TransactionCard } from "./transationTypes";

export const cardApi = createApi({
  reducerPath: "cardApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["card"],
  endpoints: (builder) => ({
    createCard: builder.mutation<Response<PaymentCard>, any>({
      query: (credentials) => ({
        url: "card/create",
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["card"],
    }),
    setDefaultCard: builder.mutation<
      Response<PaymentCard>,
      { card_id: string }
    >({
      query: (credentials) => ({
        url: "card/setDefault",
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["card"],
    }),
    getCardList: builder.query<Response<PaymentCard[]>, any>({
      query: (credentials) => ({
        url: "card/list",
        method: "Get",
        data: credentials,
      }),
      providesTags: ["card"],
    }),
    getInvoiceList: builder.query<Response<TransactionCard[]>, any>({
      query: (credentials) => ({
        url: "transaction/list",
        method: "Get",
        data: credentials,
      }),
    }),
    deleteCard: builder.mutation<Response<PaymentCard>, { id: string }>({
      query: (credentials) => ({
        url: "card/" + credentials.id,
        method: "DELETE",
        data: credentials,
      }),
      invalidatesTags: ["card"],
    }),
    getGiftCredit: builder.query<
      Response<{ remaining_credits: string }>,
      undefined
    >({
      query: () => ({
        url: "transaction/gift-credits",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateCardMutation,
  useSetDefaultCardMutation,
  useGetCardListQuery,
  useDeleteCardMutation,
  useGetInvoiceListQuery,
  useGetGiftCreditQuery,
} = cardApi;
